// DO NOT MODIFY, this file is autogenerated by tools/build.ts
// Export a null object with the same keys as firebase/compat/analytics, so Proxy can work with proxy-polyfill in Internet Explorer
export const proxyPolyfillCompat = {
  app: null,
  logEvent: null,
  setCurrentScreen: null,
  setUserId: null,
  setUserProperties: null,
  setAnalyticsCollectionEnabled: null,
};
